<template>
  <aside v-if="auditHealth.failed || auditHealth.dropped" class="audit-health-banner" role="alert">
    <strong>Some activity records have not been saved.</strong>
    <span
      >Your work may already be saved; do not repeat the original action just to create a log.</span
    >
    <span
      >{{ auditHealth.failed }} awaiting retry<span v-if="auditHealth.dropped"
        >; {{ auditHealth.dropped }} could not be queued</span
      >. Keep this tab open while retrying.</span
    >
    <button
      type="button"
      :disabled="!!auditHealth.pending || !auditHealth.failed"
      @click="retryAuditDelivery"
    >
      Retry activity logs
    </button>
    <small v-if="auditHealth.lastReference"
      >Support reference: {{ auditHealth.lastReference }}</small
    >
  </aside>
</template>
<script setup>
import { watch } from 'vue'
import { useAuthStore } from '@/store/authStore'
import { auditHealth, retryAuditDelivery, clearAuditDelivery } from '@/utils/auditDelivery'
const auth = useAuthStore()
watch(
  () => auth.currentUser?.uid,
  (next, previous) => {
    if (previous && next !== previous) clearAuditDelivery()
  }
)
</script>
<style scoped>
.audit-health-banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 14px;
  padding: 12px 20px;
  background: #fff7ed;
  color: #7c2d12;
  border-bottom: 1px solid #fdba74;
}
.audit-health-banner small {
  overflow-wrap: anywhere;
}
.audit-health-banner button {
  padding: 6px 10px;
  border: 1px solid #9a3412;
  border-radius: 4px;
  background: white;
  color: #7c2d12;
  cursor: pointer;
}
</style>
